module.exports = __webpack_public_path__ + "img/cladify_logo_sm.2014553e.png";